/** @jsxImportSource theme-ui */
import React, { useState } from 'react'
import { ModalBody, Modal } from '@pancakeswap/uikit'
import { ModalProps} from '@ape.swap/uikit'
import useActiveWeb3React from 'hooks/useActiveWeb3React'
import { ChainId } from '@ape.swap/sdk'
import { NETWORK_LABEL } from 'config/constants/chains'
import { useTranslation } from 'contexts/Localization'
import MoonPayIframe from './MoonFrame'

// Supported chains for moonpay
const SUPPORTED_CHAINS = [ChainId.BSC, ChainId.MAINNET, ChainId.MATIC, ChainId.ARBITRUM]

export default function MoonPayModal({ onDismiss }: ModalProps) {
  const [accept, setAccept] = useState(false)
  const { t } = useTranslation()
  const { chainId } = useActiveWeb3React()
  const modalProps = {
    style: {
      zIndex: 10,
      overflowY: 'auto',
      maxHeight: 'calc(100% - 30px)',
    },
    sx: {
      minWidth: '437px',
      '@media screen and (max-width: 437px)': {
        minWidth: '95%',
      },
      maxWidth: '437px',
    },
  } 
  return (
    <Modal title={t('Buy with Fiat')}  onDismiss={onDismiss} >
              <ModalBody >
        <MoonPayIframe />  
        </ModalBody>
    </Modal>
  )
}
